import { atom } from 'recoil';

export const companyState = atom<string | null>({
  key: 'companyState',
  default: null,
});

export const isCompanyOptionsUpdateNeeded = atom<boolean>({
  key: 'isCompanyOptionsUpdateNeeded',
  default: false,
});
